"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Datepicker;

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.replace.js");

require("core-js/modules/es.string.match.js");

require("core-js/modules/es.parse-float.js");

require("core-js/modules/es.regexp.to-string.js");

require("react-date-range/dist/styles.css");

require("react-date-range/dist/theme/default.css");

var _reactDateRange = require("react-date-range");

var _DatepickerModule = _interopRequireDefault(require("../../assets/styles/components/Datepicker.module.scss"));

var rdrLocales = _interopRequireWildcard(require("react-date-range/dist/locale"));

var _Dropdown = _interopRequireDefault(require("../inputs/Dropdown"));

var _react = require("react");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// main style file
// theme css file
function Datepicker(_ref) {
  let {
    closeOnSelect,
    onChange,
    styling = {},
    range = false,
    value,
    rangeValue,
    disabled = false,
    maxDate,
    minDate,
    startTime = false,
    endTime = false,
    quickSelect = false,
    displayWrapper = true,
    isClearable = false,
    positive = false,
    error = false,
    locale = "en-GB",
    direction = "bottom",
    placeholder = "YYYY/MM/DD"
  } = _ref;
  const [yearDdl, setyearDdl] = (0, _react.useState)([]);
  const [locale_state, setlocale_state] = (0, _react.useState)(rdrLocales.enGB);
  (0, _react.useEffect)(() => {
    let lc = locale.replace(/\W/g, '');

    if (lc.length === 4 && rdrLocales[lc]) {
      setlocale_state(rdrLocales[lc]);
    } else {
      if (rdrLocales[lc.substring(0, 2)]) {
        setlocale_state(rdrLocales[lc.substring(0, 2)]);
      } else {
        setlocale_state(rdrLocales.enGB);
      }
    }
  }, [locale]);
  (0, _react.useEffect)(() => {
    let min = 1922;
    let max = 2040;
    let tmp = [];

    while (max > min) {
      tmp.push(max);
      max--;
    }

    setyearDdl(tmp);
  }, []);
  (0, _react.useEffect)(() => {
    if (rangeValue && range) {
      changeInputValue(rangeValue);
    }
  }, [rangeValue]);
  (0, _react.useEffect)(() => {
    if (value && range === false) {
      changeInputValue(value);
    }
  }, [value]);
  (0, _react.useEffect)(() => {
    if (minDate !== "") {
      if (isValidDate(stringToDate(minDate)) && minDate.length > 3) {
        setmindate(new Date(stringToDate(minDate)));
      }
    }
  }, [minDate]);
  (0, _react.useEffect)(() => {
    if (maxDate !== "") {
      if (isValidDate(stringToDate(maxDate)) && maxDate.length > 3) {
        setmaxdate(new Date(stringToDate(maxDate)));
      }
    }
  }, [maxDate]);
  const [updater, setupdater] = (0, _react.useState)(0);
  const [startDate, setstartDate] = (0, _react.useState)(null);
  const [ranges, setranges] = (0, _react.useState)({
    startDate: null,
    endDate: new Date(""),
    key: 'selection'
  });
  const [shownDate, setshownDate] = (0, _react.useState)(new Date());
  const [inputValue, setinputValue] = (0, _react.useState)("");
  const [quickselectValue, setquickselectValue] = (0, _react.useState)("");
  const [starttimeValue, setstarttimeValue] = (0, _react.useState)("");
  const [endtimeValue, setendtimeValue] = (0, _react.useState)("");
  const [mindate, setmindate] = (0, _react.useState)(null);
  const [maxdate, setmaxdate] = (0, _react.useState)(null);

  const stringToDate = value => {
    let year = "";
    let month = "";
    let day = "";
    let finalStr = "";

    if (!value) {
      value = "";
    }

    value = value.replace(/\D/g, '');

    if (!value) {
      value = "";
    }

    if (value.split("/").join("").match(/.{1,2}/g)) {
      year = value.split("/").join("").match(/.{1,2}/g)[0];

      if (value.split("/").join("").match(/.{1,2}/g)[1]) {
        year += value.split("/").join("").match(/.{1,2}/g)[1];

        if (year.length === 4) {
          year += "/";
        }
      }

      if (value.split("/").join("").match(/.{1,2}/g)[2]) {
        if (parseFloat(value.split("/").join("").match(/.{1,2}/g)[2]) > 12) {
          month = "12/";
        } else {
          month = value.split("/").join("").match(/.{1,2}/g)[2] + "/";
        }
      }

      if (value.split("/").join("").match(/.{1,2}/g)[3]) {
        if (parseFloat(value.split("/").join("").match(/.{1,2}/g)[3]) > 31) {
          day = "31";
        } else {
          day = value.split("/").join("").match(/.{1,2}/g)[3];
        }
      }
    }

    finalStr = year + month + day;
    return finalStr;
  };

  const monthSelector = type => {
    let currentMonth = shownDate.getMonth() + 1;
    let currentYear = shownDate.getFullYear();

    if (type === "substract") {
      currentMonth--;
    } else {
      currentMonth++;
    }

    if (currentMonth === 0) {
      currentMonth = 12;
      currentYear--;
    }

    if (currentMonth === 13) {
      currentMonth = 1;
      currentYear++;
    }

    setupdater(updater + 1);
    setshownDate(new Date(currentYear, currentMonth, 0));
  };

  function getMonthName(monthNumber) {
    const date = new Date();
    date.setMonth(monthNumber - 1);
    return date.toLocaleString('en-US', {
      month: 'long'
    });
  }

  const changeInputValue = value => {
    let year = "";
    let month = "";
    let day = "";
    let finalStr = "";
    let e_year = "";
    let e_month = "";
    let e_day = "";
    value = value.replace(/\D/g, '');

    if (!value) {
      value = "";
    }

    if (value.split("/").join("").match(/.{1,2}/g)) {
      year = value.split("/").join("").match(/.{1,2}/g)[0];

      if (value.split("/").join("").match(/.{1,2}/g)[1]) {
        year += value.split("/").join("").match(/.{1,2}/g)[1];

        if (year.length === 4) {
          year += "/";
        }
      }

      if (value.split("/").join("").match(/.{1,2}/g)[2]) {
        if (parseFloat(value.split("/").join("").match(/.{1,2}/g)[2]) > 12) {
          month = "12/";
        } else {
          month = value.split("/").join("").match(/.{1,2}/g)[2] + "/";
        }
      }

      if (value.split("/").join("").match(/.{1,2}/g)[3]) {
        if (parseFloat(value.split("/").join("").match(/.{1,2}/g)[3]) > 31) {
          day = "31";
        } else {
          day = value.split("/").join("").match(/.{1,2}/g)[3];
        }
      }
    }

    finalStr = year + month + day;

    if (range && value.split("/").join("").match(/.{1,2}/g)) {
      let partTwo = value.split("/").join("").match(/.{1,2}/g).slice(4);

      if (partTwo.join("")) {
        e_year = partTwo.join("").match(/.{1,2}/g)[0];

        if (partTwo.join("").match(/.{1,2}/g)[1]) {
          e_year += parseFloat(partTwo.join("").match(/.{1,2}/g)[1]);

          if (e_year.length === 4) {
            e_year += "/";
          }
        }

        if (partTwo.join("").match(/.{1,2}/g)[2]) {
          if (parseFloat(partTwo.join("").match(/.{1,2}/g)[2]) > 12) {
            e_month = "12";
          } else {
            e_month = partTwo.join("").match(/.{1,2}/g)[2];
          }

          e_month += "/";
        }

        if (partTwo.join("").match(/.{1,2}/g)[3]) {
          if (parseFloat(partTwo.join("").match(/.{1,2}/g)[3]) > 31) {
            e_day = "31";
          } else {
            e_day = partTwo.join("").match(/.{1,2}/g)[3];
          }
        }

        finalStr += " - " + e_year + e_month + e_day;
      }
    }

    if (!range) {
      if (isValidDate(new Date(finalStr))) {
        setstartDate(new Date(finalStr));
        setshownDate(new Date(finalStr));
      }
    } else {
      let obj = {
        startDate: null,
        endDate: new Date(""),
        key: 'selection'
      };

      if (finalStr.split(" - ")[0].length === 10) {
        obj.startDate = new Date(finalStr.split(" - ")[0]);
        setshownDate(obj.startDate);
      }

      if (finalStr.split(" - ")[1]) {
        if (finalStr.split(" - ")[1].length === 10) {
          obj.endDate = new Date(finalStr.split(" - ")[1]);
        }
      }

      setranges(obj);
    }

    setinputValue(finalStr);
  };

  function formatDate(date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    return [year, month, day].join('/');
  }

  const isValidDate = dateObject => new Date(dateObject).toString() !== 'Invalid Date';

  const changeShownDate = (type, value) => {
    let tmp_sd = shownDate;

    if (type === "month") {
      tmp_sd.setMonth(parseFloat(value.value) - 1);
    }

    if (type === "year") {
      tmp_sd.setFullYear(value.value);
    }

    setshownDate(tmp_sd);
    setupdater(updater + 1);
  };

  const handleQuickSelect = value => {
    switch (value.value.toString().toLowerCase()) {
      case "today":
        let td = new Date();

        if (!range) {
          setshownDate(td);
          setstartDate(td);
          setinputValue(formatDate(td));
        } else {
          setshownDate(td);
          setranges({
            startDate: td,
            endDate: td,
            key: 'selection'
          });
          setinputValue(formatDate(td) + " - " + formatDate(td));
        }

        break;

      case "yesterday":
        let yd = new Date();
        yd.setDate(yd.getDate() - 1);

        if (!range) {
          setshownDate(yd);
          setstartDate(yd);
          setinputValue(formatDate(yd));
        } else {
          setshownDate(yd);
          setranges({
            startDate: yd,
            endDate: yd,
            key: 'selection'
          });
          setinputValue(formatDate(yd) + " - " + formatDate(yd));
        }

        break;

      case "last week":
        let lw = new Date();
        let lwtd = new Date();
        lw.setDate(lw.getDate() - 7);

        if (!range) {
          setshownDate(lw);
          setstartDate(lw);
          setinputValue(formatDate(lw));
        } else {
          setshownDate(lw);
          setranges({
            startDate: lw,
            endDate: lwtd,
            key: 'selection'
          });
          setinputValue(formatDate(lw) + " - " + formatDate(lwtd));
        }

        break;

      case "last month":
        let lm = new Date();
        let lmtd = new Date();
        lm.setMonth(lm.getMonth() - 1);

        if (!range) {
          setshownDate(lm);
          setstartDate(lm);
          setinputValue(formatDate(lm));
        } else {
          setshownDate(lm);
          setranges({
            startDate: lm,
            endDate: lmtd,
            key: 'selection'
          });
          setinputValue(formatDate(lm) + " - " + formatDate(lmtd));
        }

        break;

      case "last 3 months":
        let ltm = new Date();
        let ltmtd = new Date();
        ltm.setMonth(ltm.getMonth() - 3);

        if (!range) {
          setshownDate(ltm);
          setstartDate(ltm);
          setinputValue(formatDate(ltm));
        } else {
          setshownDate(ltm);
          setranges({
            startDate: ltm,
            endDate: ltmtd,
            key: 'selection'
          });
          setinputValue(formatDate(ltm) + " - " + formatDate(ltmtd));
        }

        break;

      case "last 6 months":
        let lsm = new Date();
        let lsmtd = new Date();
        lsm.setMonth(lsm.getMonth() - 6);

        if (!range) {
          setshownDate(lsm);
          setstartDate(lsm);
          setinputValue(formatDate(lsm));
        } else {
          setshownDate(lsm);
          setranges({
            startDate: lsm,
            endDate: lsmtd,
            key: 'selection'
          });
          setinputValue(formatDate(lsm) + " - " + formatDate(lsmtd));
        }

        break;

      case "last year":
        let ly = new Date();
        let lytd = new Date();
        ly.setFullYear(ly.getFullYear() - 1);

        if (!range) {
          setshownDate(ly);
          setstartDate(ly);
          setinputValue(formatDate(ly));
        } else {
          setshownDate(ly);
          setranges({
            startDate: ly,
            endDate: lytd,
            key: 'selection'
          });
          setinputValue(formatDate(ly) + " - " + formatDate(lytd));
        }

        break;

      default:
        break;
    }

    setquickselectValue(value.value);
  };

  const changeStartTime = (type, value) => {
    let hour = "";
    let minutes = "";
    let finalStr = "";
    value = value.replace(/\D/g, '');

    if (!value) {
      value = "";
    }

    if (value.split(":").join("").match(/.{1,2}/g)) {
      if (hour = value.split(":").join("").match(/.{1,2}/g)[0]) {
        if (parseFloat(value.split(":").join("").match(/.{1,2}/g)[0]) > 23) {
          hour = "23";
        } else {
          hour = value.split(":").join("").match(/.{1,2}/g)[0];
        }

        if (hour.length === 2) {
          hour += ":";
        }
      }

      if (value.split(":").join("").match(/.{1,2}/g)[1]) {
        if (parseFloat(value.split(":").join("").match(/.{1,2}/g)[1]) > 59) {
          minutes = "59";
        } else {
          minutes = value.split(":").join("").match(/.{1,2}/g)[1];
        }
      }
    }

    finalStr = hour + minutes;

    if (type === "starttime") {
      setstarttimeValue(finalStr.replace(/\s/g, ''));
    }

    if (type === "endtime") {
      setendtimeValue(finalStr.replace(/\s/g, ''));
    }
  };

  const dateInput = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    if (dateInput.current) {
      dateInput.current.setAttribute('size', dateInput.current.getAttribute('placeholder').length + 1);
    }
  }, [dateInput, range]);

  const clearDate = () => {
    setupdater(updater + 1);
    setstartDate(null);
    setranges({
      startDate: null,
      endDate: new Date(""),
      key: 'selection'
    });
    setshownDate(new Date());
    setinputValue("");
    setquickselectValue("");
    setstarttimeValue("");
    setendtimeValue("");
  };

  (0, _react.useEffect)(() => {
    document.addEventListener("click", onClickOutside);
  }, []);
  const calendarRef = (0, _react.useRef)(null);
  const [calendar_isOpened, setcalendar_isOpened] = (0, _react.useState)(false);

  const onClickOutside = e => {
    if (calendarRef.current) {
      if (e.target === calendarRef.current || calendarRef.current.contains(e.target) || e.target.id === "action") {//Click inside
      } else {
        //Click outside
        setcalendar_isOpened(false);
      }
    }
  };

  (0, _react.useEffect)(() => {
    if (range) {
      onChange(ranges);
    } else {
      onChange(startDate);

      if (closeOnSelect) {
        setcalendar_isOpened(false);
      }
    }
  }, [startDate, ranges]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: _DatepickerModule.default.datepicker,
      ref: calendarRef,
      style: styling,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "".concat(_DatepickerModule.default.inputContainer, " ").concat(positive && _DatepickerModule.default.positive, " ").concat(error && _DatepickerModule.default.error),
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
          onFocus: () => {
            setcalendar_isOpened(true);
          },
          ref: dateInput,
          className: _DatepickerModule.default.dateInput,
          disabled: disabled,
          type: "text",
          placeholder: range ? "".concat(placeholder, " - ").concat(placeholder) : "".concat(placeholder),
          value: inputValue,
          onChange: e => {
            changeInputValue(e.currentTarget.value);
          },
          maxLength: range ? 23 : 10
        }), startTime && /*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
          onFocus: () => {
            setcalendar_isOpened(true);
          },
          className: _DatepickerModule.default.hourInput,
          type: "text",
          placeholder: "HH:MM",
          onChange: e => {
            changeStartTime("starttime", e.currentTarget.value);
          },
          value: starttimeValue
        }), endTime && /*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
          onFocus: () => {
            setcalendar_isOpened(true);
          },
          className: _DatepickerModule.default.hourInput,
          type: "text",
          placeholder: "HH:MM",
          onChange: e => {
            changeStartTime("endtime", e.currentTarget.value);
          },
          value: endtimeValue
        }), isClearable && /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
          onClick: () => {
            clearDate();
          },
          className: _DatepickerModule.default.clearButton,
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "black",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("line", {
              x1: "18",
              y1: "6",
              x2: "6",
              y2: "18"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("line", {
              x1: "6",
              y1: "6",
              x2: "18",
              y2: "18"
            })]
          })
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: {
          visibility: calendar_isOpened ? "visible" : "hidden",
          opacity: calendar_isOpened ? "1" : "0"
        },
        className: "".concat(_DatepickerModule.default.calendar, " ").concat(direction === "bottom" ? _DatepickerModule.default.direction_bottom : direction === "top" ? _DatepickerModule.default.direction_top : _DatepickerModule.default.direction_bottom),
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("section", {
          children: [displayWrapper && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: _DatepickerModule.default.displayWrapper,
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
              id: "action",
              className: _DatepickerModule.default.displayWrapperButton,
              onClick: () => {
                monthSelector("substract");
              },
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
                x: "0px",
                y: "0px",
                id: "action",
                viewBox: "0 0 10 10",
                style: {
                  height: "10px",
                  width: "10px"
                },
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    id: "action",
                    d: "M1.3,5.5c-0.4-0.2-0.4-0.8,0-1.1l3.4-2l3.4-2C8.5,0.3,9,0.6,9,1.1V5v3.9c0,0.5-0.5,0.8-0.9,0.5l-3.4-2L1.3,5.5z"
                  })
                })
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Dropdown.default, {
              keepSelectedItem: true,
              type: "ID_LABEL",
              hideIcon: true,
              styling: {
                maxWidth: "8rem",
                padding: ".7rem 0.3rem"
              },
              options: ["1_January", "2_Februari", "3_March", "4_April", "5_May", "6_June", "7_July", "8_August", "9_September", "10_October", "11_November", "12_Decemeber"],
              selected: ["".concat(shownDate.getMonth() + 1, "_").concat(getMonthName(shownDate.getMonth() + 1))],
              isMulti: false,
              isSearchable: false,
              size: "mini",
              placeholder: "",
              onChange: value => {
                changeShownDate("month", value);
              }
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Dropdown.default, {
              keepSelectedItem: true,
              hideIcon: true,
              styling: {
                maxWidth: "6rem",
                padding: ".7rem .3rem"
              },
              options: yearDdl,
              selected: [shownDate.getFullYear()],
              isMulti: false,
              isSearchable: true,
              size: "mini",
              placeholder: "",
              onChange: value => {
                changeShownDate("year", value);
              }
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
              id: "action",
              className: _DatepickerModule.default.displayWrapperButton,
              onClick: () => {
                monthSelector("add");
              },
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
                x: "0px",
                y: "0px",
                id: "action",
                viewBox: "0 0 10 10",
                style: {
                  height: "10px",
                  width: "10px"
                },
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    id: "action",
                    d: "M8.7,5.5c0.4-0.2,0.4-0.8,0-1.1l-3.4-2l-3.4-2C1.5,0.3,1,0.6,1,1.1V5v3.9c0,0.5,0.5,0.8,0.9,0.5l3.4-2L8.7,5.5z"
                  })
                })
              })
            })]
          }), !range && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactDateRange.Calendar, {
              locale: locale_state,
              maxDate: maxdate,
              minDate: mindate,
              weekStartsOn: 1,
              shownDate: isValidDate(shownDate) ? shownDate : new Date(null),
              date: isValidDate(startDate) ? startDate : new Date(null),
              onChange: date => {
                setinputValue(formatDate(date));
                setstartDate(date);
              }
            })
          }), range && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactDateRange.DateRangePicker, {
              locale: locale_state,
              maxDate: maxdate,
              minDate: mindate,
              weekStartsOn: 1,
              shownDate: shownDate,
              staticRanges: [],
              inputRanges: [],
              ranges: [ranges],
              onChange: date => {
                setinputValue(formatDate(date.selection.startDate) + " - " + formatDate(date.selection.endDate));
                setranges(date.selection);
                setquickselectValue("");
              }
            })
          })]
        }), quickSelect && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: _DatepickerModule.default.quickselect,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
            className: _DatepickerModule.default.option_label,
            children: "Quickselect"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Dropdown.default, {
            styling: {
              width: "100%"
            },
            isClearable: true,
            options: ["Today", "Yesterday", "Last week", "Last month", "Last 3 months", "Last 6 months", "Last year"],
            selected: [quickselectValue],
            isMulti: false,
            isSearchable: false,
            hideIcon: true,
            keepSelectedItem: true,
            disabled: false,
            size: "compact",
            placeholder: "None",
            onChange: value => {
              handleQuickSelect(value);
            }
          })]
        }), startTime && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: _DatepickerModule.default.starttime,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
            className: _DatepickerModule.default.option_label,
            children: "Start time"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Dropdown.default, {
            styling: {
              width: "100%"
            },
            isClearable: true,
            options: ["12:00", "12:15", "12:30", "12:45", "13:00", "13:15", "13:30", "13:45", "14:00", "14:15", "14:30", "14:45", "15:00", "15:15", "15:30", "15:45", "16:00", "16:15", "16:30", "16:45", "17:00", "17:15", "17:30", "17:45", "18:00", "18:15", "18:30", "18:45", "19:00", "19:15", "19:30", "19:45", "20:00", "20:15", "20:30", "20:45", "21:00", "21:15", "21:30", "21:45", "22:00", "22:15", "22:30", "22:45", "23:00", "23:15", "23:30", "23:45", "00:00", "00:15", "00:30", "00:45", "01:00", "01:15", "01:30", "01:45", "02:00", "02:15", "02:30", "02:45", "03:00", "03:15", "03:30", "03:45", "04:00", "04:15", "04:30", "04:45", "05:00", "05:15", "05:30", "05:45", "06:00", "06:15", "06:30", "06:45", "07:00", "07:15", "07:30", "07:45", "08:00", "08:15", "08:30", "08:45", "09:00", "09:15", "09:30", "09:45", "10:00", "10:15", "10:30", "10:45", "11:00", "11:15", "11:30", "11:45"],
            selected: [starttimeValue],
            isMulti: false,
            isSearchable: true,
            hideIcon: true,
            keepSelectedItem: true,
            disabled: false,
            size: "compact",
            placeholder: "HH:MM",
            onChange: value => {
              setstarttimeValue(value.value);
            }
          })]
        }), endTime && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: _DatepickerModule.default.endtime,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
            className: _DatepickerModule.default.option_label,
            children: "End time"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Dropdown.default, {
            styling: {
              width: "100%"
            },
            isClearable: true,
            options: ["12:00", "12:15", "12:30", "12:45", "13:00", "13:15", "13:30", "13:45", "14:00", "14:15", "14:30", "14:45", "15:00", "15:15", "15:30", "15:45", "16:00", "16:15", "16:30", "16:45", "17:00", "17:15", "17:30", "17:45", "18:00", "18:15", "18:30", "18:45", "19:00", "19:15", "19:30", "19:45", "20:00", "20:15", "20:30", "20:45", "21:00", "21:15", "21:30", "21:45", "22:00", "22:15", "22:30", "22:45", "23:00", "23:15", "23:30", "23:45", "00:00", "00:15", "00:30", "00:45", "01:00", "01:15", "01:30", "01:45", "02:00", "02:15", "02:30", "02:45", "03:00", "03:15", "03:30", "03:45", "04:00", "04:15", "04:30", "04:45", "05:00", "05:15", "05:30", "05:45", "06:00", "06:15", "06:30", "06:45", "07:00", "07:15", "07:30", "07:45", "08:00", "08:15", "08:30", "08:45", "09:00", "09:15", "09:30", "09:45", "10:00", "10:15", "10:30", "10:45", "11:00", "11:15", "11:30", "11:45"],
            selected: [endtimeValue],
            isMulti: false,
            isSearchable: false,
            hideIcon: true,
            keepSelectedItem: true,
            disabled: false,
            size: "compact",
            placeholder: "HH:MM",
            onChange: value => {
              setendtimeValue(value.value);
            }
          })]
        })]
      }, updater)]
    })
  });
}